import Vue from 'vue';

var VueConfirm = Vue.directive('confirm', {
    inserted(el, binding) {
        // if no reload and callback not give, throw error
        if (!isFunction(binding.value.onSuccess)) {
            throw "callback is not a function."
        }

        el.addEventListener('click', (event) => {
            var confirm = window.confirm(binding.value.message);

            event.stopPropagation();

            if (confirm === true) {
                binding.value.onSuccess(binding.value.params);
            }
        });
    }
});

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export default VueConfirm;